module.exports = __webpack_public_path__ + "static/media/logo.a3c6cb20.svg";